import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/NavBar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AdminPage from './pages/AdminPage';
import ProfilePage from './pages/ProfilePage';
import PrivateRoute from './components/PrivateRoute';
import ClassDetails from './pages/ClassDetails';
import Calendar from './components/Calendar';
import FeedbackPage from './pages/FeedbackPage';
import StudentQuizzes from './components/StudentQuizzes';
import QuizCreatePage from './pages/QuizCreatePage';
import BlogManagePage from './pages/BlogManagePage';
import HelpPage from './pages/HelpPage';
import VNPayReturn from './pages/VNPayReturn';
import CustomQuizPage from './pages/CustomQuizPage';
import QuizTakingPage from './pages/QuizTakingPage';
import Footer from './components/Footer';

const AppMainRoutes = () => (
  <main className="mx-auto w-full max-w-7xl px-4 pb-24 pt-6 sm:px-6 lg:px-8">
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <AdminPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/class/:classId"
        element={
          <PrivateRoute>
            <ClassDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/calendar"
        element={
          <PrivateRoute>
            <Calendar />
          </PrivateRoute>
        }
      />
      <Route
        path="/feedback"
        element={
          <PrivateRoute>
            <FeedbackPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/quizzes"
        element={
          <PrivateRoute>
            <StudentQuizzes />
          </PrivateRoute>
        }
      />
      <Route
        path="/custom-quizzes"
        element={
          <PrivateRoute>
            <CustomQuizPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/quiz/:quizId"
        element={
          <PrivateRoute>
            <QuizTakingPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/quiz/create"
        element={
          <PrivateRoute>
            <QuizCreatePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/quiz/edit/:id"
        element={
          <PrivateRoute>
            <QuizCreatePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/blogs"
        element={
          <PrivateRoute>
            <BlogManagePage />
          </PrivateRoute>
        }
      />
      <Route path="/help" element={<HelpPage />} />
      <Route path="/payment/vnpay-return" element={<VNPayReturn />} />
    </Routes>
  </main>
);

const App = () => (
  <Router>
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-violet-50 to-indigo-100 text-slate-800">
      <Navbar />
      <div className="flex min-h-screen flex-col pt-24">
        <div className="flex flex-1 flex-col">
          <Routes>
            <Route path="/*" element={<AppMainRoutes />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </div>
  </Router>
);

export default App;
